import type { DraftSourceGroup } from "../lib/draftSourceGroups";

export function GenerationFailureCard({
  failure,
  label,
  onRecover,
  onUpgrade,
  onDismiss,
}: {
  failure: NonNullable<DraftSourceGroup["failedRequest"]>;
  label: string;
  onRecover: (paste: boolean) => void;
  onUpgrade: () => void;
  onDismiss: () => void;
}) {
  return (
    <div
      role="alert"
      className="w-80 shrink-0 rounded-lg border border-destructive/20 bg-destructive/5 p-5 text-sm"
    >
      <p className="font-medium">
        {failure.errorCode === "no-source-images"
          ? "No images found"
          : "We couldn’t prepare your posts."}
      </p>
      <p className="mt-2 text-muted-foreground">{failure.message}</p>
      {failure.suggestion && (
        <p className="mt-2 text-muted-foreground">{failure.suggestion}</p>
      )}
      <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1">
        {failure.fallback && (
          <button
            type="button"
            className="min-h-11 rounded-sm font-medium underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            onClick={() => onRecover(true)}
          >
            {failure.fallback.type === "paste_transcript"
              ? "Paste transcript instead"
              : "Paste text instead"}
          </button>
        )}
        <button
          type="button"
          className="min-h-11 rounded-sm font-medium underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          onClick={() =>
            failure.errorCode === "insufficient_credits"
              ? onUpgrade()
              : onRecover(false)
          }
        >
          {failure.errorCode === "insufficient_credits"
            ? "Get more credits"
            : failure.errorCode === "pdf-unreadable"
            ? "Replace PDF"
            : "Review and retry"}
        </button>
        {failure.errorCode === "insufficient_credits" && (
          <button
            type="button"
            className="min-h-11 rounded-sm font-medium underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            onClick={() => onRecover(false)}
          >
            Review input
          </button>
        )}
        <button
          type="button"
          className="min-h-11 rounded-sm text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          aria-label={`Dismiss failed request: ${label}`}
          onClick={onDismiss}
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
